import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
    },
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      ticks: {
        callback: function (label, index, labels) {
          return (label / 1000000000).toLocaleString() + " M";
        },
      },
    },
  },
  maintainAspectRatio: false,
};

export default function TargetRealisasi5Tahun({
  epnbp,
  kerjasamabu,
  jasaperbankan,
  pendapatanlainlain,
  targetepnbp,
  targetkerjasamabu,
  targetjasaperbankan,
  targetpendapatanlainlain,
}) {
  const thisYear = new Date().getFullYear();
  let startYear = thisYear - 4;
  let dataRealisasi = [];
  let dataTarget = [];
  let labels = [];
  let dataTables = [];

  let datasets = [
    {
      fill: true,
      label: "Realisasi Pendapatan",
      data: [],
      borderColor: "rgb(29, 168, 73)",
      backgroundColor: "rgba(29, 168, 73, 0.2)",
    },
    {
      fill: true,
      label: "Target Pendapatan",
      data: [],
      borderColor: "rgb(14, 156, 255)",
      backgroundColor: "rgba(14, 156, 255, 0.2)",
    },
  ];

  // Proses Perhitungan Untuk Chart Target dan Realisasi 5 Tahun
  if (
    epnbp === Object(epnbp) &&
    kerjasamabu === Object(kerjasamabu) &&
    jasaperbankan === Object(jasaperbankan) &&
    pendapatanlainlain === Object(pendapatanlainlain) &&
    targetepnbp === Object(targetepnbp) &&
    targetkerjasamabu === Object(targetkerjasamabu) &&
    targetjasaperbankan === Object(targetjasaperbankan) &&
    targetpendapatanlainlain === Object(targetpendapatanlainlain)
  ) {
    Object.entries(epnbp).map(([key, value], i) => {
      let calculateRealisasi =
        value +
        Object.entries(kerjasamabu)[i][1] +
        Object.entries(jasaperbankan)[i][1] +
        Object.entries(pendapatanlainlain)[i][1];
      let calculateTarget =
        Object.entries(targetepnbp)[i][1] +
        Object.entries(targetkerjasamabu)[i][1] +
        Object.entries(targetjasaperbankan)[i][1] +
        Object.entries(targetpendapatanlainlain)[i][1];

      // Memasukkan Hasil Perhitungan kedalam Chart
      dataRealisasi.push(calculateRealisasi);
      dataTarget.push(calculateTarget);
      labels.push(key);

      // Memasukkan Hasil Perhitungan kedalam Table
      let tableData = {
        tahun: key,
        target: calculateTarget,
        realisasi: calculateRealisasi,
        persentase: Math.round((calculateRealisasi / calculateTarget) * 100),
      };
      dataTables.push(tableData);
    });
  } else {
    for (startYear; startYear <= thisYear; startYear++) {
      labels.push(startYear.toString());
      dataRealisasi.push(0);
      dataTarget.push(0);

      let tableData = {
        tahun: startYear,
        target: 0,
        realisasi: 0,
        persentase: 0,
      };
      dataTables.push(tableData);
    }
  }

  // Memasukkan Nilai data realisasi dan target ke dalam dataset
  datasets[0].data = dataRealisasi;
  datasets[1].data = dataTarget;

  // Data yang akan di passing ke dalam chart
  const data = {
    labels,
    datasets: datasets,
  };

  return (
    <>
      {/* <div className="flex flex-warp items-center"> */}
      <div className="rounded-lg bg-white border border-neutral-300">
        <div className="bg-primary-second rounded-t-lg px-8 py-6">
          <h3 className="text-base md:text-xl font-semibold text-white">
            Perbandingan Target dan Realisasi 5 Tahun
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-8">
          <div id="grafik-realisasi-target-5-tahun" className="h-64 md:h-auto">
            <Line options={options} data={data} />
          </div>
          <div id="table-realisasi-target-5-tahun" className="hidden md:block">
            <table className="table-auto min-w-full border-collapse">
              <thead>
                <tr className="bg-gray-light">
                  <th className="p-3 text-black">Tahun</th>
                  <th className="p-3 text-black">Target</th>
                  <th className="p-3 text-black">Realisasi</th>
                  <th className="p-3 text-black">%</th>
                </tr>
              </thead>
              <tbody>
                {dataTables.map((data) => (
                  <tr className="group">
                    <td className="p-3 text-center bg-gray-light text-black font-semibold">
                      {data.tahun}
                    </td>
                    <td className="p-3 text-right border border-gray-light bg-secondary-fifth text-secondary-dark font-semibold group-hover:bg-secondary-dark group-hover:text-white duration-300">
                      {data.target.toLocaleString()}
                    </td>
                    <td className="p-3 text-right border border-gray-light bg-primary-fifth text-primary-dark font-semibold group-hover:bg-primary-dark group-hover:text-white duration-300">
                      {data.realisasi.toLocaleString()}
                    </td>
                    <td className="p-3 text-center border border-gray-light bg-orange-light text-orange-dark font-semibold group-hover:bg-orange-dark group-hover:text-white duration-300">
                      {data.persentase}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
